import "./skelton.css";
export default function SkeltonLoader({height='209px'}){
    return (
        <>
            <div className="movie--isloading">
                <div className="loading-image" style={{height:height}}></div>
                <div className="loading-content">
                    <div className="loading-text-container">
                        <div className="loading-main-text"></div>
                        <div className="loading-sub-text"></div>
                    </div>
                    <div className="loading-btn"></div>
                </div>
            </div>
        </>
    );
}
